import { MSG_LOG } from '@/modules/kartoteka/partner/constants';

export { DMS_MODULE } from '../constants';
export const NAME = MSG_LOG;
export const CRUMB_LABEL_KEY = 'msgLog';
